var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudDownload = function SvgCloudDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cloud-download_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.24 15.891h1.46s4.3-.561 4.3-4.783a4.773 4.773 0 0 0-4.955-4.773A6.685 6.685 0 0 0 5.324 8.794 3.586 3.586 0 0 0 1 12.3c0 3.645 3.826 3.588 3.826 3.588h1.906M12 21V11M9 18.391l3 3 3-3",
    className: "cloud-download_svg__a"
  })));
};
export default SvgCloudDownload;